<template>
  <svg viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg">

    <g v-for="(item, idx) in list" :key="'segment-'+idx"
      :transform="'translate(100 100) rotate(' + percent2degree(item.from) + ')'"
      @click="onClickSlice(item)">

      <path
        :d="getPath( item.to - item.from, value === item.id )"
        fill="transparent"
        :stroke="value === item.id ? item.color : Color( item.color ).fade(0.5)"
        :stroke-width="value === item.id ? 100 : strokeWidth"/>

      <text
        x="50"
        text-anchor="middle"
        :fill="value === item.id ? 'white' : '#444'"
        style="font-size: 8; dominant-baseline: middle; font-weight: bold"
        :transform="'rotate(' + ( percent2degree( item.to - item.from )/2 - 90 ) + ')'">
        <tspan dy="0" dx="0">{{item.text}}</tspan>
      </text>

    </g>
  </svg>
</template>

<script>
import { COLOR_LIST } from '@/misc/colors'
import Color from 'color';

// TODO: Show how many goals already exist in each life area

export default {
  props: {
    areas: {},
    value: {}
  },
  data() {
    return {
      strokeWidth: 90,
      radius: 45,
    };
  },
  computed: {
    list() {
      let lifeAreas = this.areas;
      let alphaSegment = 100 / lifeAreas.length
      let idx = 0;
      let list = lifeAreas.map(item => {
        idx += 1;
        return {
          color: COLOR_LIST[ 2 * idx - 1 ],
          from:  ( idx - 1 ) * alphaSegment,
          to:    idx * alphaSegment,
          text:  item.text,
          id:    item.id,
        };
      });
      return list
    },
    Color() {
      return Color;
    }
  },
  methods: {
    percent2degree(percent) {
      return percent * (360 / 100);
    },
    getPath(percent, selected) {
      let radius = selected ? 50 : this.radius;
      // Where to put x coordinate of center of circle
      let x = 0;
      // Where to put y coordinate of center of circle
      let y = 0 - radius;

      // Calculate length of arc in radians
      let degrees = (percent / 100) * 360;
      let value = degrees - 180; // Turn the circle 180 degrees counter clockwise
      let radians = (value * Math.PI) / 180;

      // Calculate X coordinate of end of arc
      // add some rounding error to make arc not disappear at 100%
      let endX = -Math.sin(radians) * radius - 0.0001;
      // Calculate Y coordinate of end of arc
      let endY = Math.cos(radians) * radius;
      // If more than 50% filled we need to switch arc drawing mode from less than 180 deg to more than 180 deg
      let largeArc = percent < 50 ? 0 : 1;
      // If we reach full circle we need to complete the circle, this ties into the rounding error in X coordinate above
      let z = percent === 100 ? "z" : "";

      return (
        "M " + x + " " + y +
        " A " + radius + " " + radius + " 0 " + largeArc + " 1 " + endX + " " + endY + " " + z
      );
    },
    onClickSlice(item) {
      if ( item.id === this.value ) {
        this.$emit('input', null)
      } else {
        this.$emit('input', item.id)
      }
    }
  },
};
</script>
